/**
 * App Store / Play Store URLs for "Get the app" CTAs.
 *
 * Centralised so the PaywallSheet, /get redirect page, and any
 * future Smart App Banner / landing-page integration all reference
 * the same canonical links.
 *
 * Both listings are live. The iOS numeric id comes from App Store
 * Connect (mirrored at src/app/eas.json → submit.production.ios.
 * ascAppId); the Android package id from src/app/app.json →
 * android.package.
 *
 * The iOS URL deliberately carries NO locale segment. Apple 301s a
 * bare /app/id<digits> into the visitor's own storefront, so a UK
 * user lands on /gb/ and a US user on /us/. Pasting the URL straight
 * out of a browser gives you a locale-pinned link (/gb/app/wydm/…)
 * that would send every country to that one storefront — strip it.
 * `?mt=8` is a legacy iTunes param and is not needed.
 *
 * Any surface that renders these should mirror src/app/app/get.web.tsx,
 * which keeps its own copy (the app/ subtree can't import from web/).
 */

export const APP_STORE_URL = 'https://apps.apple.com/app/id6771992489';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.wydm.client';

// Canonical "get the app" smart-redirect URL on our own domain.
// /get sniffs the user-agent and 302s to the right store. Used as
// the QR-code payload on desktop so a phone scan lands on the right
// store without the desktop user having to pick a platform.
export const GET_THE_APP_URL = 'https://wydm.app/get';

// Subscription-management URLs — point at each store's "your
// subscriptions" page. Unlike the listing URLs above these are
// REAL today: both Apple and Google host stable manage-subs URLs
// that open the user's Apple ID / Google account subscriptions
// list. Used by the Settings plan badge's "Manage in <store>"
// link so a premium user can cancel / change tier without
// hunting through OS settings.
export const APP_STORE_MANAGE_URL  = 'https://apps.apple.com/account/subscriptions';
export const PLAY_STORE_MANAGE_URL = 'https://play.google.com/store/account/subscriptions';
